import { useCallback, useMemo } from 'react';

export const useColumnSelection = (
  hiddenColumns: string[],
  setHiddenColumns: (columns: string[]) => void,
  allColumns: string[]
) => {
  const numColumns = allColumns.length;
  const numColumnsSelected = useMemo(
    () => allColumns.filter((key) => !hiddenColumns.includes(key)).length,
    [hiddenColumns, allColumns]
  );
  const allSelected = useMemo(
    () => allColumns.every((key) => !hiddenColumns.includes(key)),
    [hiddenColumns, allColumns]
  );

  const toggleColumn = useCallback(
    (column, selected) => {
      setHiddenColumns(
        !selected
          ? hiddenColumns.filter((key) => key !== column)
          : [...hiddenColumns, column]
      );
    },
    [hiddenColumns, setHiddenColumns]
  );

  const toggleAllColumns = useCallback(
    (selected) => {
      setHiddenColumns(selected ? [] : allColumns);
    },
    [allColumns, setHiddenColumns]
  );

  return {
    numColumns,
    numColumnsSelected,
    allSelected,
    toggleColumn,
    toggleAllColumns,
  };
};
